// Clipping volume normalised by green area, so greens of different size are comparable.
// 1 L per 1000 m² = 1 mL/m². Returns null when the green has no usable area.
export function clippingMlPerM2(liters, areaM2) {
  if (liters == null || !(areaM2 > 0)) return null;
  return (liters / areaM2) * 1000;
}
